import { createSelector } from '@reduxjs/toolkit'
import {
  effectiveHomeVariant,
  isDefaultHomeVariant,
  isHomeToggleAvailable,
  geographyPlan,
} from './lib'

export const selectPartner = (state) => state.partners?.current || null
export const selectPartnerResolved = (state) =>
  Boolean(state.partners?.currentResolved)
const selectUserSettingsOverride = (state) =>
  state.partners?.userSettings || null

// Вариант, который пользователь выбрал тогглом в этой вкладке (без дефолта).
export const selectOwnHomeVariant = (state) => {
  const own = selectUserSettingsOverride(state)?.home_variant
  return own === 'v1' || own === 'v2' ? own : null
}

// Партнёр с актуальными настройками пользователя: после PATCH они лежат
// отдельно от current (см. store/partners/reducers).
const selectPartnerWithSettings = createSelector(
  selectPartner,
  selectUserSettingsOverride,
  (partner, userSettings) => {
    if (!userSettings) return partner
    return { ...(partner || {}), user_settings: userSettings }
  }
)

export const selectHomeVariant = createSelector(
  selectPartnerWithSettings,
  (partner) => effectiveHomeVariant(partner)
)

export const selectIsDefaultVariant = createSelector(
  selectPartnerWithSettings,
  (partner) => isDefaultHomeVariant(partner)
)

export const selectHomeToggleAvailable = createSelector(
  selectPartnerWithSettings,
  (partner) => isHomeToggleAvailable(partner)
)

export const selectHome = (state) => state.homeV2

export const selectHomeFilters = (state) => state.homeV2.filters
export const selectFleetSize = (state) => state.homeV2.fleetSize
export const selectCardsExpanded = (state) => state.homeV2.cardsExpanded
export const selectVariantUpdating = (state) => state.homeV2.variantUpdating

export const selectRecent = (state) => state.homeV2.recent
export const selectFacets = (state) => state.homeV2.facets
export const selectGeography = (state) => state.homeV2.geography

export const selectGeographyPlan = createSelector(
  (state) => state.homeV2.geography.data,
  (data) => geographyPlan(data)
)
